/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberAppointmentsIdCompleteMutationResponse, PostApiBarberAppointmentsIdCompletePathParams, PostApiBarberAppointmentsIdComplete400, PostApiBarberAppointmentsIdComplete401, PostApiBarberAppointmentsIdComplete403, PostApiBarberAppointmentsIdComplete404, PostApiBarberAppointmentsIdComplete500 } from "../entities/PostApiBarberAppointmentsIdComplete";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberAppointmentsIdComplete } from "../api/postApiBarberAppointmentsIdComplete";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberAppointmentsIdCompleteMutationKey = () => [{ url: '/api/barber/appointments/:id/complete' }] as const

export type PostApiBarberAppointmentsIdCompleteMutationKey = ReturnType<typeof postApiBarberAppointmentsIdCompleteMutationKey>

export function postApiBarberAppointmentsIdCompleteMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = postApiBarberAppointmentsIdCompleteMutationKey()
        return mutationOptions<PostApiBarberAppointmentsIdCompleteMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdComplete400 | PostApiBarberAppointmentsIdComplete401 | PostApiBarberAppointmentsIdComplete403 | PostApiBarberAppointmentsIdComplete404 | PostApiBarberAppointmentsIdComplete500>, {id: PostApiBarberAppointmentsIdCompletePathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return postApiBarberAppointmentsIdComplete(id, config)
          },
        })

}

/**
 * @description Мастер завершает стрижку
 * @summary Завершить стрижку
 * {@link /api/barber/appointments/:id/complete}
 */
export function usePostApiBarberAppointmentsIdComplete<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberAppointmentsIdCompleteMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdComplete400 | PostApiBarberAppointmentsIdComplete401 | PostApiBarberAppointmentsIdComplete403 | PostApiBarberAppointmentsIdComplete404 | PostApiBarberAppointmentsIdComplete500>, {id: PostApiBarberAppointmentsIdCompletePathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberAppointmentsIdCompleteMutationKey()

          const baseOptions = postApiBarberAppointmentsIdCompleteMutationOptions(config) as UseMutationOptions<PostApiBarberAppointmentsIdCompleteMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdComplete400 | PostApiBarberAppointmentsIdComplete401 | PostApiBarberAppointmentsIdComplete403 | PostApiBarberAppointmentsIdComplete404 | PostApiBarberAppointmentsIdComplete500>, {id: PostApiBarberAppointmentsIdCompletePathParams["id"]}, TContext>
          

          return useMutation<PostApiBarberAppointmentsIdCompleteMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdComplete400 | PostApiBarberAppointmentsIdComplete401 | PostApiBarberAppointmentsIdComplete403 | PostApiBarberAppointmentsIdComplete404 | PostApiBarberAppointmentsIdComplete500>, {id: PostApiBarberAppointmentsIdCompletePathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberAppointmentsIdCompleteMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdComplete400 | PostApiBarberAppointmentsIdComplete401 | PostApiBarberAppointmentsIdComplete403 | PostApiBarberAppointmentsIdComplete404 | PostApiBarberAppointmentsIdComplete500>, {id: PostApiBarberAppointmentsIdCompletePathParams["id"]}, TContext>
      
}